<template>
  <div class="container orderView-wrapper">
    <div class="orderview">
      <div class="bg"></div>
      <div class="order_content">
        <div class="order_status">
          <div class="status_item">
            <div class="status_text">{{order.orderstatus | orderStatus}}</div>
            <van-button type="danger" v-if="order.orderstatus === 0" @click="orderPay">立即付款</van-button>
          </div>
        </div>
        <div class="product_item">
          <div
            class="goods-list activity-order"
            v-for="product in order.orderitemlist"
            :key="product.id"
            @click="goActivity(product.productid)"
            >
            <div class="goods-info">
              <div class="goods-title van-multi-ellipsis--l2">{{product.productname}}</div>
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="product_mes">
          <div class="mes_list" v-if="order.orderstatus === 0">
            <div class="mes_label">订单总额：</div>
            <div class="mes_val redColor">￥{{order.amount}}</div>
          </div>
          <div class="mes_list" v-if="order.orderstatus !== 0 && order.orderstatus !== 4">
            <div class="mes_label">支付方式：</div>
            <div class="mes_val">{{order.paytype === 0 ? '微信支付' : '支付宝支付'}}</div>
          </div>
        </div>
        <div class="product_mes">
          <div class="mes_list">
            <div class="mes_label">订单编号：</div>
            <div class="mes_val">{{order.orderno}}</div>
          </div>
          <div class="mes_list">
            <div class="mes_label">下单时间：</div>
            <div class="mes_val">{{order.createdate}} {{order.createtime}}</div>
          </div>
          <div class="mes_list" v-if="order.orderstatus !== 0 && order.orderstatus !== 4">
            <div class="mes_label">付款金额：</div>
            <div class="mes_val redColor">￥{{order.amount}}</div>
          </div>
          <div class="mes_list" v-if="order.orderstatus !== 0 && order.orderstatus !== 4">
            <div class="mes_label">付款时间：</div>
            <div class="mes_val">￥{{order.paydate}} {{order.paytime}}</div>
          </div>
        </div>
        <van-button class="cancelOrder" type="default" block v-if="order.orderstatus === 0" @click="cancelOrder">取消订单</van-button>
        <a class="cancelOrder" href="tel://020-83341279" v-if="order.orderstatus !== 0">联系客服</a>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  import throttle from 'lodash/throttle'
  const u = navigator.userAgent
  export default {
    name: 'activityOrder',
    data () {
      return {
        order: {}
      }
    },
    created () {
      // console.log()
      this.$toast.allowMultiple()
      if (u.indexOf('MicroMessenger') > -1) {
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let url=''
        if (isAndroid) {
          url=location.href
        }
        if (isIOS) {
          url=location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
        }
        this.$fetch.get(API.GETWECHATINVOKESIGN, {
          url: url
        }).then(response => {
          let data = response.data
          wx.config({
            beta: true,
            debug: false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
        })
      }
      this.getData()
    },
    mounted () {
    },
    methods: {
      getData () {
        const load = this.$toast({
          type: 'loading',
          duration: 0,
          loadingType: 'spinner',
          forbidClick: true
        })
        this.$fetch.get(API.ORDERDETAIL, {
          orderid: this.$route.query.id
        }).then(response => {
          // console.log(response)
          load.clear()
          if (response.status !== 200) {
            var msg = response.message? response.message : '订单详情获取失败，请刷新！'
            this.$toast.fail(msg)
            return
          }
          this.order = response.data
        }).catch(error => {
          load.clear()
          console.log(error)
        })
      },
      goActivity (id) {
        this.$router.push({path: '/activity/view', query: {id: id}})
      },
      cancelOrder () {
        this.$dialog.confirm({
          message: '是否取消该订单？'
        }).then(() => {
          const load = this.$toast({
            type: 'loading',
            duration: 0,
            loadingType: 'spinner',
            forbidClick: true
          })
          this.$fetch.post(API.ORDERCANCEL, {
            orderid: this.order.id
          }).then(response => {
            load.clear()
            if (response.status !== 200) {
              var msg = response.message? response.message : '订单取消失败，请刷新重试！'
              this.$toast.fail(msg)
              return
            }
            this.getData()
          }).catch(error => {
            load.clear()
            console.log(error)
          })
        }).catch(() => {
        })
      },
      orderPay: throttle(function() {
        if (u.indexOf('MicroMessenger') > -1) {
          this.$fetch.post(API.WECHATPAY, {
            orderno: this.order.orderno
          }).then(response => {
            // console.log(response.data)
            let data = response.data
            let options = {
              timestamp: data.timeStamp, // 时间戳，自1970年以来的秒数
              nonceStr: data.nonceStr, // 随机串
              package: data.package,
              signType: data.signType, // 微信签名方式:
              paySign: data.paySign, // 微信签名
              success: (res) => {
                // console.log(res)
                this.$router.replace({path:'/activity/result', query: {id: this.order.id, type: 'order'}})
                // if (res.errMsg === 'chooseWXPay:ok') {
                //   this.$toast.success({
                //     message: '订单付款成功！',
                //     duration: 1500,
                //     forbidClick: true,
                //     onClose: this.getData()
                //   })
                // } else {
                //   this.$toast.fail({
                //     message: '支付遇到问题，请联系客服确认',
                //     duration: 1500,
                //     forbidClick: true,
                //     onClose: this.getData()
                //   })
                // }
              },
              cancel: (res) => {
                // console.log(res)
                this.$toast.fail('已取消订单支付')
              },
              fail: (res) => {
                this.$router.replace({path:'/activity/result', query: {id: this.order.id, type: 'order'}})
                // this.$toast.fail({
                //   message: '支付遇到问题，请联系客服确认',
                //   duration: 1500,
                //   forbidClick: true,
                //   onClose: this.getData()
                // })
              }
            }
            // 唤起微信支付
            wx.chooseWXPay(options)
          })
        } else {
          this.$fetch.post(API.ALIPAY, {
            orderno: this.order.orderno
          }).then(response => {
            // console.log(response)
            if (response.status !== 200) {
              var msg = response.message? response.message : '支付宝唤起支付失败，请刷新重试！'
              this.$toast.fail(msg)
              return
            }
            window.location.href = response.data.payurl
            // this.alipayWap = response
          }).catch(err => {
            console.log(err)
          })
        }
      }, 3000, { 'trailing': false })
    },
    filters: {
      orderStatus (status) {
        switch (status)
        {
          case 0:
            return '订单待付款'
            break;
          case 1:
            return '订单已付款'
            break;
          case 2:
            return '订单退款中'
            break;
          case 3:
            return '订单已退款'
            break;
          case 4:
            return '订单已取消'
            break;
          case 5:
            return '订单已完成'
            break;
          case 6:
            return '订单已付款'
            break;
        }
      }
    }
  }
</script>

<style lang="stylus">
</style>